import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PagesApp.css';
import AIArtGirl2 from '../../assets/images/components/Art2.png';
import AIArtGirl3 from '../../assets/images/components/Art3.png';
import AIArtGirl4 from '../../assets/images/components/Art4.png';
import AIArtGirl5 from '../../assets/images/components/Art5.png';
import AIArtGirl6 from '../../assets/images/components/Art6.png';
import AIArtGirl7 from '../../assets/images/components/Art7.png';
import AIArtGirl8 from '../../assets/images/components/Art8.png';

const PagesApp = () => {
    const navigate = useNavigate();
    const [selectedImage, setSelectedImage] = useState(null);

    // Array of all possible images
    const images = [
        AIArtGirl2,
        AIArtGirl3,
        AIArtGirl4,
        AIArtGirl5,
        AIArtGirl6,
        AIArtGirl7,
        AIArtGirl8
    ];

    useEffect(() => {
        // Get the last displayed image path from localStorage
        const lastImage = localStorage.getItem('lastDisplayedPagesImage');

        // Select a random image that's different from the last one
        let randomIndex;
        let newImage;

        do {
            randomIndex = Math.floor(Math.random() * images.length);
            newImage = images[randomIndex];
        } while (newImage === lastImage && images.length > 1);

        // Save the new image to localStorage for next time
        localStorage.setItem('lastDisplayedPagesImage', newImage);

        // Set the selected image
        setSelectedImage(newImage);
    }, []);

    // Add useEffect for scroll prevention
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.height = '100%';
        document.body.style.touchAction = 'none';

        return () => {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = 'unset';
            document.body.style.position = 'static';
            document.body.style.width = 'auto';
            document.body.style.height = 'auto';
            document.body.style.touchAction = 'auto';
        };
    }, []);

    const handleViewPages = () => {
        navigate('/main/app');
    }

    return (
        <div className="pages-login-container">
            <div className="pages-mobile-frame">
                {/* Home button positioned at top right for mobile */}
                <div className="pages-home-button-container">
                    <span onClick={() => navigate('/')}
                        className='pages-home-button'>HOME</span>
                </div>
                <div className="pages-login-content">
                    <div className="pages-login-image-wrapper">
                        <div className="pages-image-container">
                            {selectedImage && (
                                <img
                                    src={selectedImage}
                                    alt="AI Art"
                                    className="pages-login-image"
                                />
                            )}
                            <div className="pages-image-gradient"></div>
                        </div>
                        <div className="pages-login-branding">
                            <p className="uppercase tracking-[3px] font-medium">P A G E S</p>
                        </div>
                    </div>
                    <div className="pages-login-buttons !bottom-[-5px]">
                        <button
                            className="pages-login-button reduced-height"
                            onClick={handleViewPages}
                        >
                            View Pages
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PagesApp; 